import { render, staticRenderFns } from "./SrMasterActivity.vue?vue&type=template&id=1986d03d&"
import script from "./SrMasterActivity.vue?vue&type=script&lang=js&"
export * from "./SrMasterActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports